import { AlbumFile } from '@/models/albumFile.ts'
import { ComponentType } from 'react'

export interface FileAction {
  label: string
  icon: ComponentType<{ size?: number | string; className?: string }>
  onClick: (file: AlbumFile) => void
  className?: string
  /** Only offer the action for files this returns true for (e.g. image-only actions). Default: all files. */
  isAvailable?: (file: AlbumFile) => boolean
}

export function getAvailableActions(actions: FileAction[], file: AlbumFile): FileAction[] {
  return actions.filter(action => !action.isAvailable || action.isAvailable(file))
}

interface FileHoverOverlayProps {
  file: AlbumFile
  actions: FileAction[]
  visible: boolean
  /** Hide the hover file name when the tile already shows a permanent one. */
  hideFileName?: boolean
}

/** The file name bar as shown on hover — reused for the permanent variant. */
export function FileNameBar({ file, className }: { file: AlbumFile; className?: string }) {
  return (
    <div className={`bg-secondary px-2 py-1 text-base-content text-xs truncate ${className || ''}`} title={file.file_name}>
      {file.file_name}
    </div>
  )
}

export default function FileHoverOverlay({ file, actions, visible, hideFileName }: FileHoverOverlayProps) {
  return (
    <div
      className={`absolute inset-0 hidden md:flex flex-col justify-between pointer-events-none transition-opacity duration-200 ${visible ? 'opacity-100' : 'opacity-0'}`}
    >
      {hideFileName ? <div /> : <FileNameBar file={file} />}
      <div className="flex justify-center gap-1 p-1.5 pointer-events-auto">
        {getAvailableActions(actions, file).map((action) => (
          <button
            key={action.label}
            title={action.label}
            className={`btn btn-circle btn-sm bg-secondary hover:bg-base-300 border-none text-base-content ${action.className || ''}`}
            onClick={(e) => {
              e.stopPropagation()
              action.onClick(file)
            }}
          >
            <action.icon size={16} />
          </button>
        ))}
      </div>
    </div>
  )
}
